import { Option } from '@eiq/ui';

import { BlockLoopSourceEnum } from '@empathy/survey/base';

export const BlockLoopSourceOptions: Option<BlockLoopSourceEnum>[] = [
  {
    value: BlockLoopSourceEnum.Question,
    text: 'From Question'
  },
  {
    value: BlockLoopSourceEnum.Options,
    text: 'Custom list'
  },
  { value: BlockLoopSourceEnum.Media, text: 'From Stimulus' }
];
